export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Виджетті жасау"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бас тарту"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Шот"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Генерациялау"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Төлем"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Төлем сомасы"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сәтті болған кезде әрекеттер"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сәтсіз болған кезде әрекеттер"])}
}